import email from "../assets/logo/gmail.png";
import instagram from "../assets/logo/instagram.png";
import youtube from "../assets/logo/youtube.png";
import linkedin from "../assets/logo/linkedin.png";
import topmate from "../assets/logo/topmatelogo.png";
import github from "../assets/logo/github.png";
import location from "../assets/logo/location.png";
import medium from "../assets/logo/medium.png";

const contactData = [
    {
        type: "email",
        logo: email,
        content: "vasantharank.work@gmail.com"
    },
    {
        type: "instagram",
        logo: instagram,
        content: "https://www.instagram.com/vasantharan_k/"
    },
    {
        type: "youtube",
        logo: youtube,
        content: "https://www.youtube.com/@TechKalviTalks"
    },
    {
        type: "github",
        logo: github,
        content: "https://www.github.com/vasantharan"
    },
    {
        type: "linkedin",
        logo: linkedin,
        content: "https://www.linkedin.com/in/vasantharank/"
    },
    {
        type: "medium",
        logo: medium,
        content: "https://vasantharan.medium.com/"
    },
    {
        type: "topmate",
        logo: topmate,
        content: "https://topmate.io/vasantharan"
    },
    {
        type: "location",
        logo: location,
        content: "Tenkasi, Tamil Nadu, India"
    },
];

export default contactData;